import Footer from '@app/components/Footer/Footer'
import Navbar from '@app/components/Navbar/Navbar'
import React, { FC } from 'react'
import S from './styles'

const RedirectPartialView: FC = () => {
  return (
    <>
      <Navbar />
      <S.QuizMain>
        <div />
      </S.QuizMain>
      <Footer />
    </>
  )
}

export default RedirectPartialView
